import React from 'react'
import { BurgerSection } from '../../Drawer/DrawerHeader'
import { useMarketplace } from '../../../hooks/useMarketplace'
import { LoadingSpinner } from '../../Loaders/LoadingSpinner'
import { CustomerLoyaltyCard } from '../../CustomerLoyaltyCard/CustomerLoyaltyCard'
import { useTranslation } from 'react-i18next'
import { useCustomerDetailsAndAddressesQuery } from '../../../hooks/sharedQueries/useCustomerDetailsAndAddressesQuery/useCustomerDetailsAndAddressesQuery'

const LoyaltyListWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { loyaltyCardSectionHeader } = useMarketplace()
  const { t } = useTranslation('customerLoyaltyCard')
  return (
    <BurgerSection
      header={{
        title: t('my_loyalty_cards', {
          chosenHeaderName: loyaltyCardSectionHeader ?? 'Loyalty Card',
        }),
      }}
    >
      {children}
    </BurgerSection>
  )
}

export const LoyaltyList: React.FC = () => {
  const { data, loading } = useCustomerDetailsAndAddressesQuery()

  if (loading) {
    return (
      <LoyaltyListWrapper>
        <LoadingSpinner text="Loading Loyalty Card List" />
      </LoyaltyListWrapper>
    )
  }

  if (!data) {
    return (
      <LoyaltyListWrapper>
        <div>Error loading loyalty cards</div>
      </LoyaltyListWrapper>
    )
  }

  return (
    <LoyaltyListWrapper>
      {data.customerDetails.loyaltyCards
        .toSorted(
          (a, b) => b.loyaltyCardStamps.length - a.loyaltyCardStamps.length
        )
        .map((loyaltyCard, index, loyaltyCards) => (
          <CustomerLoyaltyCard
            loyaltyCard={loyaltyCard}
            key={loyaltyCard.id}
            isFinalCard={index === loyaltyCards.length - 1}
            isAccountsSection
            page="burger-menu-list"
          />
        ))}
    </LoyaltyListWrapper>
  )
}
